// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-pickup-modal__content[data-v-6113dce3]{max-width:470px;margin:0 auto}@media(max-width:450px){.no-pickup-modal__content>img[data-v-6113dce3]{width:250px;height:250px}}", ""]);
// Exports
module.exports = exports;
